<template>
  <div class="content-header-title">
    <h1>{{ title }}</h1>
    <div class="content-header-title--image">
      <img class="img-fluid" :src="require(`@/assets/img/image-${image}.png`)" alt="image planos" title="image planos"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'image'],
}
</script>

<style lang="scss">
.content-header-title {
  padding: 30px 0px;
  display: flex;
  align-items: center;
  h1 {
    font-size: 24px;
    font-family: 'Font Regular';
    color: var(--black);
    margin-right: 15px;
    margin-bottom: 0;
  }
  &--image {
    img {
      max-width: 30px;
      max-height: 30px;
    }
  }
}
</style>
